import React, { useState, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { GAME_STAGE } from "../../utils/constant";
import { history } from "../../index";
import { GameModalLayout } from "../common";
import { Typography } from "@material-ui/core";
import { checkGameStatus, fetchDiagnosis } from "../../service/logic";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { fontSize } from "../../styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { OutputChecklist } from "../common/output-checklist";

const useStyles = makeStyles((theme) => ({
  modal: {
    width: "100%",
    display: "flex",
    marginTop: 14,
    alignItems: "flex-start",
    marginBottom: "1%",
    flexDirection: "row",
    justifyContent: "space-between",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  bottomwriting: {
    display: "flex",
    borderRadius: 10,
    width: "100%",
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
  },
  sectionwriting: {
    display: "flex",
    borderRadius: 10,
    width: "49%",
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginBottom: "3%",
    },
  },
}));

const DiagnosisEvaluation = () => {
  useEffect(() => {
    // check if user is allowed to enter presentation page
    if (!checkGameStatus(GAME_STAGE.FINAL_DIAGNOSIS_EVALUATION)) {
      // if not allowed, navigate to case list page
      history.push("/cases");
    }
    // fetch diagnosis evaluation
    fetchDiagnosis("final");
  }, []);

  const classes = useStyles();
  const theme = useTheme();
  const isWidthSm = useMediaQuery(theme.breakpoints.down("xs"));
  const [value, setValue] = useState("yourAnswer");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const _yourAnswer = (mobileFlag) => {
    return (
      <div id="yourAnswer" className={classes.sectionwriting}>
        <OutputChecklist
          title={mobileFlag ? "" : "Your Diagnosis"}
          type="diagnosis"
          category="final"
        />
      </div>
    );
  };

  const _sampleAnswer = (mobileFlag) => {
    return (
      <div id="sampleAnswer" className={classes.sectionwriting}>
        <OutputChecklist
          title={mobileFlag ? "" : "Diagnosis"}
          type="diagnosis"
          category="final"
          isAnswer
        />
      </div>
    );
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <GameModalLayout
        full
        left={
          <>
            <Typography variant="h2">Diagnosis (Evaluation)</Typography>
            {isWidthSm ? (
              <div>
                <div className={classes.modal}>
                  <Tabs
                    style={{ width: "100%" }}
                    indicatorColor="primary"
                    textColor="primary"
                    value={value}
                    variant="fullWidth"
                    onChange={handleChange}
                    aria-label="simple tabs example"
                  >
                    <Tab
                      style={{ textTransform: "none ", fontSize: fontSize.h4 }}
                      label="Your Diagnosis"
                      value="yourAnswer"
                      wrapped
                      id="wrapped-tab-differential"
                      aria-controls="wrapped-tabpanel-differential"
                    />
                    <Tab
                      style={{ textTransform: "none ", fontSize: fontSize.h4 }}
                      label="Diagnosis"
                      value="sampleAnswer"
                      wrapped
                      id="wrapped-tab-provisional"
                      aria-controls="wrapped-tabpanel-provisional"
                    />
                  </Tabs>
                  <div className={classes.modal}>
                    {value === "yourAnswer"
                      ? _yourAnswer(true)
                      : _sampleAnswer(true)}
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ flex: 9 }}>
                <div>
                  <div className={classes.modal}>
                    {_yourAnswer()}
                    {_sampleAnswer()}
                  </div>
                </div>
              </div>
            )}
          </>
        }
      />
    </React.Fragment>
  );
};

export default DiagnosisEvaluation;
